import SweetAlertContainer from "../../../Components/BonusUi/SweetAlert/SweetAlertContainer";

const SweetAlert = () => {
  return <SweetAlertContainer />;
};

export default SweetAlert;
